import { generateClientErrorMessage } from "../utils/generateClientErrorMessage"
import { api } from "../config/api"

// Confirmação de presença da LP /ghexperience (API do blog: POST /registerghexperience).
export const registerGhExperience = async (body) => {
    try {
        const res = await api.post('/registerghexperience', body)

        if (res.status !== 200) {
            // O interceptor da api devolve o erro em vez de lançar: o status HTTP fica em res.response.
            return { success: false, status: res.response?.status, message: generateClientErrorMessage(res) }
        }

        return { success: true, data: res.data.data }

    } catch (error) {
        console.error(error)
        return { success: false, status: error.response?.status, message: generateClientErrorMessage(error) }
    }
}
